export default __webpack_public_path__ + "static/media/add.95e04dcf.svg";